export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLight-Latin1-c6af06155ecb6c4752bd9c58e98bb100.woff2";